import { BaseService, GET, QueryMap, Signal } from 'ts-retrofit3';

import type { IResponse } from '@/Module/Core/Model/ApiModel';
import { HttpService } from '@/Module/Core/Service';
import { COURSE_API } from '@/Module/Lesson/Constant';
import type {
  IGetCourseBySlugQuery,
  IGetCourseBySlugQueryAndCategoryCategoryId,
  IGetCourseList,
  IGetCourseListByCategoryCategoryIdQuery,
} from '@/Module/Lesson/Model/ApiModel';
import type { ICourse, ICourseV2 } from '@/Module/Lesson/Model/DataModel';

class CourseService extends BaseService {
  @GET(COURSE_API.GET_LIST_BY_CATEGORY_CATEGORY_ID)
  async getList(
    @QueryMap _query: IGetCourseListByCategoryCategoryIdQuery,
    @Signal _signal?: AbortSignal,
  ): Promise<IResponse<ICourse[]>> {
    return <IResponse>{};
  }

  @GET(COURSE_API.GET_BY_SLUG)
  async getBySlug(@QueryMap _query: IGetCourseBySlugQuery, @Signal _signal?: AbortSignal): Promise<IResponse<ICourse>> {
    return <IResponse>{};
  }

  @GET(COURSE_API.GET_LIST)
  async getListV2(@QueryMap _query: IGetCourseList, @Signal _signal?: AbortSignal): Promise<IResponse<ICourseV2[]>> {
    return <IResponse>{};
  }

  @GET(COURSE_API.GET_BY_SLUG_AND_CATEGORY_CATEGORY_ID)
  async getBySlugAndCategoryCategoryId(
    @QueryMap _query: IGetCourseBySlugQueryAndCategoryCategoryId,
    @Signal _signal?: AbortSignal,
  ): Promise<IResponse<ICourse>> {
    return <IResponse>{};
  }
}

export default HttpService.build(CourseService);
